import { useState, useEffect } from 'react'
import Image from '../Image'

const Avatar = ({ src, className = '', width = 80, quality = 50 }) => {
    const [filePath, setFilePath] = useState('/images/defaultAvatar.svg')

    useEffect(() => {
        if (src) {
            const secureUrl = src.secure_url.split('/')
            setFilePath(`https://res.cloudinary.com/oplos/image/upload/w_${width}/q_${quality}/${secureUrl[6]}/${secureUrl[7]}`)
        } else {
            setFilePath('/images/defaultAvatar.svg')
        }
    }, [src])

    return (
        <Image
            className={className}
            src={filePath}
            alt={'avatar'}
        />
    )
}

export default Avatar;